module.exports = __webpack_public_path__ + "static/media/people-around-a-table-with-food-4262172.d17019a0.jpg";